import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, Select, Table, Statistic, Tag, Input, message, Button, Tooltip } from 'antd';
import moment from 'moment';
import { useGlobalState } from '../../../store/state';
import { BsFilter } from 'react-icons/bs';
import { VscEye } from 'react-icons/vsc';
import { dateRangeSeperator } from '../../../utils';
import './CampaignsTableComponent.styles.scss';
import PlatformIconRender from '../../Common/PlatformIconRender';
import { CampaignList } from '../../../apis/Admin/Campaigns/CampaignList';
import { AiOutlineSearch } from 'react-icons/ai';
import { SearchCampaign } from '../../../apis/Admin/Campaigns/SearchCampaign';
import { Link } from 'react-router-dom';

const { RangePicker } = DatePicker;
const { Option } = Select;
const CampaignsTableComponent = () => {
  const filterRef = useRef();
  // const rangeRef = useRef()
  // const searchRef = useRef()
  const [user] = useGlobalState('user');
  // const [company] = useGlobalState('company');
  const [camps, setCamps] = useState({
    searching: false,
    query: '',
    range: [moment().subtract(180, 'days'), moment()],
    filter: 'all',
    pager: {
      page: 1,
      total: 0,
      limit: 10,
    },
    data: [],
  });

  // @note: common function for get Campaigns
  const getCampaignList = (status, page, limit) =>{
    setCamps({
      ...camps,
      query: '',
      // searching:false,
      filter: status,
      data: [],
    });
    CampaignList(user.accessToken, { status, page, limit }).then(({ status, response })=>{
      console.log('fetched camps', response);
      if (status === 200) {
        const _d = response.campaigns.map((camp)=>{
          return {
            key: camp.id,
            name: camp.name || 'N/A',
            id: camp.id || 'N/A',
            // brand:camp.brand.name || 'N/A',
            company: camp.brand.companyname || 'N/A',
            companyId: camp.brand.id || 'N/A',
            objective: camp.objective || 'N/A',
            startdate: moment(camp.startdate).format('Do MMM YYYY'),
            enddate: moment(camp.enddate).format('Do MMM YYYY'),
            platform: camp.platform || 'N/A',
            status: camp.campaignstatus || 'N/A',
            paymentCompleted: camp.paymentstatus,
          };
        });
        setCamps({
          ...camps,
          query: '',
          // filter:filter,
          searching: false,
          pager: {
            ...camps.pager,
            page: response.page,
            limit: response.limit,
            total: response.totalDocs,
          },
          data: _d.reverse(),
        });
      }
    });
  };
  const getCampaignSearchList = (query, page, limit) =>{
    setCamps({
      ...camps,
      searching: true,
      query: query,
      filter: 'all',
      data: [],
    });
    SearchCampaign(user.accessToken, { query, page, limit }).then(({ status, response })=>{
      console.log('fetched search camps', response);
      if (status === 200) {
        const _d = response.campaigns.map((camp)=>{
          return {
            key: camp.id,
            name: camp.name || 'N/A',
            id: camp.id || 'N/A',
            brand: camp.brandname || 'N/A',
            company: camp.companyname || 'N/A',
            objective: camp.objective || 'N/A',
            startdate: moment(camp.startdate).format('Do MMM YYYY'),
            enddate: moment(camp.enddate).format('Do MMM YYYY'),
            platform: camp.platform || 'N/A',
            status: camp.campaignstatus || 'N/A',
            paymentCompleted: camp.paymentstatus,
          };
        });
        setCamps({
          ...camps,
          query: query,
          searching: true,
          // filter:"all",
          pager: {
            ...camps.pager,
            page: response.page,
            limit: response.limit,
            total: response.totalDocs,
          },
          data: _d.reverse(),
        });
      } else {
        message.error('There is some issue to get search result');
      }
    });
  };

  useEffect(()=>{
    // const {range,filter,pager:{page}} = txnState
    // getTransactionDetails(range,filter,page)
    getCampaignList(camps.filter, camps.pager.page, camps.pager.limit);
  }, []);


  // @note: table columns setup
  const columns = [
    {
      title: 'Campaign Name',
      dataIndex: 'name',
      render: (v, other) =>(
        <>
          <p className="m-0"><strong>{v}</strong></p>
          <p className="m-0"
            style={{ fontSize: '0.7rem', color: '#999' }}>{other.id}</p>
        </>
      ),
    },
    {
      with: 100,
      title: 'Company',
      dataIndex: 'company',
      render: (v, other) =>(
        <>
          <p className="m-0"
            title={`id: ${other.companyId}`}><strong>{v}</strong></p>
          {/* <p className="m-0" style={{fontSize:'0.7rem',color:"#999"}}>{other.companyId}</p> */}
        </>
      ),
    },
    {
      title: 'Objective',
      align: 'center',
      dataIndex: 'objective',
      //   render: (v,other) =>(
      //         <>
      //             <p className="m-0" style={{fontSize:'0.7rem',color:"#999"}}>{v}</p>
      //         </>
      //     )
    },
    {
      width: 150,
      title: 'Date(Start-End)',
      dataIndex: 'startdate',
      align: 'center',
      render: (v, other) =>(
        <>
          <div style={{ fontSize: '12px' }}>{v}</div>
          <div className="text-center"
            style={{ fontSize: '12px' }}>To</div>
          <div style={{ fontSize: '12px' }}>{other.enddate}</div>
        </>
      ),
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      align: 'center',
      render: (v) => <PlatformIconRender platform={v}
        size={24}/>,
    },
    {
      width: 80,
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (_v) =>{
        switch (_v) {
        case 'review':
          return <Tag color="purple"
            className="m-0">{_v}</Tag>;
        case 'published':
          return <Tag color="lime"
            className="m-0">{_v}</Tag>;
        case 'active':
          return <Tag color="green"
            className="m-0">{_v}</Tag>;
        case 'closed':
          return <Tag color="red"
            className="m-0">{_v}</Tag>;
        case 'rejected':
          return <Tag color="red"
            className="m-0">{_v}</Tag>;
        default:
          return <Tag color="gold"
            className="m-0"
            style={{ maxWidth: 80, white: 'break-all', whiteSpace: 'pre-wrap' }}>{_v}</Tag>;
        }
      },
    },
    {
      width: 100,
      title: 'Payment Status',
      dataIndex: 'paymentCompleted',
      align: 'center',
      render: (v) =>(
        v ? <Tag color="green">Completed</Tag> : <Tag color="gold">Pending</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'download',
      align: 'center',
      width: 80,
      render: (v, other) => {
        if (other.status === 'published') {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=creatives`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        } else if (other.status === 'active') {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=statistics`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        } else {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=brief`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        }
      },
    },
  ];

  // @note: page changing if more than
  const changePage = (page) =>{
    const { pager, filter, query, searching } = camps;
    // getTransactionDetails(range,filter,page)
    // setCamps({
    //     ...camps,
    //     pager:{
    //         ...camps.pager,
    //         page:page
    //     }
    // })
    if (searching === true) {
      console.log('query', query);
      getCampaignSearchList(query, page, pager.limit);
    } else {
      console.log('am filtering', filter);
      getCampaignList(filter, page, pager.limit);
    }
  };

  // @note: change on payment mode
  const changeTypeFilter = (filter) =>{
    console.log('filter', filter);
    const { pager } = camps;
    getCampaignList(filter, 1, pager.limit);
  };


  const onSearchCampaign = (query) =>{
    const { pager } = camps;
    if (query.length >= 3) {
      getCampaignSearchList(query, 1, pager.limit);
    } else {
      message.warning('Please Search with Minimum 3 characters');
    }
  };

  // @note reset all table fileters and search
  const resetAllTable = () =>{
    const { pager } = camps;
    getCampaignList('all', 1, pager.limit);
  };
  const searchOnChange = (e) =>{
    // searchRef.current.state.value = '';
    setCamps({
      ...camps,
      query: e.target.value,
    });
  };

  // @note: filter Date wise
  // const dateFilter = (range) =>{
  //     const {filter} = camps
  //     setCamps({
  //         ...camps,
  //         range:range
  //     })
  // }


  // @note: diable future dates in date filter
  // const disableFutureDates = (current) =>{
  //     return current && current > moment().endOf('day');
  // }
  return (
    <div className="common_card p-3 txn_history h-100">
      <div className="row">
        <div className="col-md-3">
          <span className="txn_history--title">Filter by</span>
          <span className="pl-3">
            <Select defaultValue={camps.filter}
              className="d-inline-block common_select"
              style={{ minWidth: 150 }}
              onChange={changeTypeFilter}>
              <Select.Option value="all">All</Select.Option>
              <Select.Option value="draft">Draft</Select.Option>
              <Select.Option value="review">In Review</Select.Option>
              <Select.Option value="published">Published</Select.Option>
              <Select.Option value="active">Active</Select.Option>
              <Select.Option value="completed">Completed</Select.Option>
              <Select.Option value="rejected">Rejected</Select.Option>
              <Select.Option value="delete">delete</Select.Option>
            </Select>
          </span>
        </div>
        <div className="col-md-3 pl-md-2">
          {/* <div className="common_search">
                        <Input placeholder="Search Campaign" allowClear size="large" prefix={<AiOutlineSearch/>} onChange={onSearchCampaign}/>
                    </div> */}
          <Input.Search onChange={searchOnChange}
            value={camps.query}
            className="common_input"
            placeholder="Search Campaign"
            enterButton
            onSearch={onSearchCampaign}/>

        </div>
        <div className="col-md-6 text-right">
          <span>
            <Tooltip title="Reset Search and filters">
              <Button className="common_button outlined small"
                onClick={resetAllTable}>Reset</Button>
            </Tooltip>
          </span>
          {/* <span ><BsFilter size={24}/></span>
                    <span className="pl-3">
                        <RangePicker
                            ref={rangeRef}
                            style={{maxWidth:300}}
                            format={`MMM Do, YYYY`}
                            disabledDate={disableFutureDates}
                            defaultValue={setCamps.range}
                            // onChange={dateFilter}
                            ranges={{
                                Today: [moment(), moment()],
                                "This Month": [moment().startOf("month"), moment()],
                                "This Week": [moment().startOf("week"), moment()],
                                "Last 30 Days": [moment().subtract(30, "days"), moment()],
                                "Last 6 months": [moment().subtract(180, "days"), moment()],
                            }}
                        />
                    </span> */}
        </div>
        <div className="col-md-12 mt-4">
          <Table
            columns={columns}
            dataSource={camps.data.reverse() || []}
            pagination={{
              current: camps.pager.page,
              total: camps.pager.total,
              showSizeChanger: false,
              showQuickJumper: true,
              onChange: (v) => changePage(v),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CampaignsTableComponent;
